<template>
  <tr v-if="tableMode">
    <td :colspan="colSpan" class="text-center py-8">
      <div class="flex justify-center items-center">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    </td>
  </tr>
  <div v-else class="flex justify-center items-center py-8">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    colSpan: {
      type: Number,
      default: 1
    },
    tableMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>
